import React from 'react';
import debounce from 'lodash/debounce';

import * as actions from '../../actions';
import template from './JobBoardHeader.rt';

export default class JobBoardHeader extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      term: ''
    };

    this.debouncedSearch = debounce(this.searchJob, 250);

  }

  setSearchTerm = (term) => {
    this.setState({term}, () => {
      this.debouncedSearch(term);
    });
  }

  searchJob = (term) => {
    this.props.dispatch(actions.jobBoardSetSearchTerm(term));
  }

  render() {
    return template.apply(this);
  }
};

